<template>
  <div class="image-preview-container" @wheel.prevent="handleWheel" @mousedown="handleMouseDown" @touchstart="handleTouchStart">
    <!-- 关闭按钮 -->
    <div class="close-btn" @click="close">
      <svg viewBox="0 0 1024 1024" width="24" height="24" fill="#fff">
        <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m165.4 618.2l-66-0.3L512 563.4l-99.3 118.4-66.1 0.3c-4.4 0-8-3.6-8-8 0-1.9 0.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1 0.3L512 464.6l99.3-118.4 66-0.3c4.4 0 8 3.6 8 8 0 1.9-0.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path>
      </svg>
    </div>

    <!-- 图片区域 -->
    <div class="image-wrapper">
      <img 
        v-for="(src, index) in imageList" 
        v-show="currentIndex === index"
        :key="index" 
        :src="src" 
        class="preview-image"
        :style="imageStyle"
        draggable="false"
        @load="handleImageLoad"
      />
    </div>

    <!-- 工具栏 (放大/缩小/旋转/重置) -->
    <div class="toolbar">
      <div class="tool-btn" @click="zoomIn">
        <svg viewBox="0 0 1024 1024" width="24" height="24" fill="#fff"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"></path>
          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"></path>
        </svg>
      </div>
      <div class="tool-btn" @click="zoomOut">
        <svg viewBox="0 0 1024 1024" width="24" height="24" fill="#fff"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"></path>
          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z"></path>
        </svg>
      </div>
      <div class="tool-btn" @click="rotate">
        <svg viewBox="0 0 1024 1024" width="24" height="24" fill="#fff"><path d="M928.44 386.28c-12.48-12.48-32.76-12.48-45.24 0l-72.2 72.2C780.68 292.4 657.48 192 512 192c-176.72 0-320 143.28-320 320s143.28 320 320 320c74.96 0 143.84-25.84 198.28-69.12 13.96-11.16 16.2-31.52 5.04-45.48-11.16-13.96-31.52-16.2-45.48-5.04C627.6 743.56 572.68 764 512 764c-138.76 0-252-113.24-252-252s113.24-252 252-252c110.32 0 203.92 71.24 237.36 169.88l-75.36-75.36c-12.48-12.48-32.76-12.48-45.24 0-12.48 12.48-12.48 32.76 0 45.24l129.92 129.92c12.48 12.48 32.76 12.48 45.24 0l129.92-129.92c12.48-12.48 12.48-32.76 0-45.24z"></path></svg>
      </div>
      <div class="tool-btn" @click="reset">
        <svg viewBox="0 0 1024 1024" width="24" height="24" fill="#fff"><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"></path></svg>
      </div>
    </div>

    <!-- 切换按钮 (上一张/下一张) -->
    <template v-if="imageList.length > 1">
      <div class="arrow-btn left" @click.stop="prevImage">
        <svg viewBox="0 0 1024 1024" width="32" height="32" fill="#fff"><path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8c-16.4 12.8-16.4 37.5 0 50.3l450.8 352.1c5.3 4.1 12.9 0.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path></svg>
      </div>
      <div class="arrow-btn right" @click.stop="nextImage">
        <svg viewBox="0 0 1024 1024" width="32" height="32" fill="#fff"><path d="M300 805.7V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1c16.4-12.8 16.4-37.5 0-50.3L312.9 134.7c-5.3-4.1-12.9-0.4-12.9 6.3v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281-360 281.1c-3.8 3-6.1 7.7-6.1 12.6z"></path></svg>
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  imageList: {
    type: Array,
    default: () => []
  },
  initialIndex: {
    type: Number,
    default: 0
  }
});

const emit = defineEmits(['close']);

// 状态
const currentIndex = ref(props.initialIndex);
const scale = ref(1);
const rotateDeg = ref(0);
const translateX = ref(0);
const translateY = ref(0);

// 拖拽相关状态
const isDragging = ref(false);
const startX = ref(0);
const startY = ref(0);
const lastTranslateX = ref(0);
const lastTranslateY = ref(0);

// 移动端触摸相关状态
const touchStartDist = ref(0);
const initialScale = ref(1);

// 计算图片样式
const imageStyle = computed(() => {
  return {
    transform: `translate(${translateX.value}px, ${translateY.value}px) scale(${scale.value}) rotate(${rotateDeg.value}deg)`,
    transition: isDragging.value ? 'none' : 'transform 0.3s ease'
  };
});

// 方法
const close = () => {
  emit('close');
};

const handleImageLoad = () => {
  reset();
};

const zoomIn = () => {
  if (scale.value < 3) {
    scale.value += 0.2;
  }
};

const zoomOut = () => {
  if (scale.value > 0.6) {
    scale.value -= 0.2;
  }
};

const rotate = () => {
  rotateDeg.value += 90;
};

const reset = () => {
  scale.value = 1;
  rotateDeg.value = 0;
  translateX.value = 0;
  translateY.value = 0;
};

const nextImage = () => {
  reset();
  if (currentIndex.value < props.imageList.length - 1) {
    currentIndex.value++;
  } else {
    currentIndex.value = 0;
  }
};

const prevImage = () => {
  reset();
  if (currentIndex.value > 0) {
    currentIndex.value--;
  } else {
    currentIndex.value = props.imageList.length - 1;
  }
};

// 滚轮缩放
const handleWheel = (e) => {
  if (e.deltaY < 0) {
    zoomIn();
  } else {
    zoomOut();
  }
};

// 鼠标按下
const handleMouseDown = (e) => {
  // 只有左键点击且缩放比例大于1时才允许拖拽
  if (e.button !== 0 || scale.value <= 1) return;
  
  isDragging.value = true;
  startX.value = e.clientX;
  startY.value = e.clientY;
  lastTranslateX.value = translateX.value;
  lastTranslateY.value = translateY.value;
  
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
};

// 鼠标移动
const handleMouseMove = (e) => {
  if (!isDragging.value) return;
  
  const dx = e.clientX - startX.value;
  const dy = e.clientY - startY.value;
  
  translateX.value = lastTranslateX.value + dx;
  translateY.value = lastTranslateY.value + dy;
};

// 鼠标松开
const handleMouseUp = () => {
  isDragging.value = false;
  document.removeEventListener('mousemove', handleMouseMove);
  document.removeEventListener('mouseup', handleMouseUp);
};

// 触摸开始 (处理双指缩放和单指拖拽)
const handleTouchStart = (e) => {
  if (e.touches.length === 1) {
    // 单指拖拽
    if (scale.value > 1) {
      isDragging.value = true;
      startX.value = e.touches[0].clientX;
      startY.value = e.touches[0].clientY;
      lastTranslateX.value = translateX.value;
      lastTranslateY.value = translateY.value;
    }
  } else if (e.touches.length === 2) {
    // 双指缩放
    const dist = Math.hypot(
      e.touches[0].clientX - e.touches[1].clientX,
      e.touches[0].clientY - e.touches[1].clientY
    );
    touchStartDist.value = dist;
    initialScale.value = scale.value;
    isDragging.value = false;
  }
};

// 触摸移动
const handleTouchMove = (e) => {
  if (e.touches.length === 1 && isDragging.value) {
    // 单指拖拽逻辑
    const dx = e.touches[0].clientX - startX.value;
    const dy = e.touches[0].clientY - startY.value;
    translateX.value = lastTranslateX.value + dx;
    translateY.value = lastTranslateY.value + dy;
  } else if (e.touches.length === 2) {
    // 双指缩放逻辑
    e.preventDefault(); // 防止页面滚动
    const dist = Math.hypot(
      e.touches[0].clientX - e.touches[1].clientX,
      e.touches[0].clientY - e.touches[1].clientY
    );
    const scaleChange = dist / touchStartDist.value;
    scale.value = Math.min(Math.max(initialScale.value * scaleChange, 0.6), 3);
  }
};

// 触摸结束
const handleTouchEnd = () => {
  isDragging.value = false;
};

onMounted(() => {
  window.addEventListener('touchmove', handleTouchMove, { passive: false });
  window.addEventListener('touchend', handleTouchEnd);
});

onUnmounted(() => {
  window.removeEventListener('touchmove', handleTouchMove);
  window.removeEventListener('touchend', handleTouchEnd);
  document.removeEventListener('mousemove', handleMouseMove);
  document.removeEventListener('mouseup', handleMouseUp);
});
</script>

<style scoped>
.image-preview-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  user-select: none;
}

.image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none; /* 关键：让事件穿透到父容器 */
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  cursor: grab;
  pointer-events: auto; /* 恢复图片本身的交互 */
  transition: transform 0.3s ease;
  will-change: transform; /* 性能优化 */
}

.preview-image:active {
  cursor: grabbing;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 2001;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.toolbar {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px 20px;
  border-radius: 30px;
  z-index: 2001;
}

.tool-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.tool-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.arrow-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 2001;
  transition: background-color 0.3s;
}

.arrow-btn:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.arrow-btn.left {
  left: 20px;
}

.arrow-btn.right {
  right: 20px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .arrow-btn {
    width: 36px;
    height: 36px;
  }
  
  .arrow-btn.left {
    left: 10px;
  }
  
  .arrow-btn.right {
    right: 10px;
  }

  .toolbar {
    bottom: 20px;
    padding: 8px 16px;
    gap: 15px;
  }
}
</style>
